<template>
    <div id="contents" class="contents full-list">
        <JsonLd :json="jsonld" />
        <div class="breadcrumb">
            <ul>
                <li>
                    <router-link :to="{name: 'Index'}">TOP</router-link>
                </li>
                <li>Full List</li>
            </ul>
        </div>

        <h1 class="ttl">All Japan <br class="sp-only">Heritage Sites</h1>

        <div class="tabMenu">
            <ul>
                <li :class="{'active' : activeTabMenu === 'fullList'}">
                    <router-link :to="{name: 'FullList'}" @click.native="activeTabMenu = 'fullList';">Full List</router-link>
                </li>
                <li :class="{'active' : activeTabMenu === 'byRegion'}">
                    <router-link :to="{name: 'FullList', query: { tab: 'region', map: 'all' }}" @click.native="activeTabMenu = 'byRegion'; activeMap = 'all'">By Region</router-link>
                </li>
                <li :class="{'active' : activeTabMenu === 'byCategory'}">
                    <router-link :to="{name: 'FullList', query: { tab: 'category' }}" @click.native="activeTabMenu = 'byCategory';">By Category</router-link>
                </li>
            </ul>
        </div>
        <div class="tabBody">

            <!-- （１）フルリスト -->
            <div v-if="activeTabMenu === 'fullList'" class="tabBody-fullList">
                <div class="articleBlock">
                    <div class="group">
                        <h2 class="ttl">Full List</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in articles" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['fullList'], article.attributes.url)" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['fullList'], article.attributes.url)" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'full_list_txt'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'full_list_txt', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /フルリスト -->

            <!-- （２）地域 -->
            <div v-if="activeTabMenu === 'byRegion'" class="tabBody-region" id="region">
                <!-- 全国地図 -->
                <div class="map-all" v-if="activeMap === 'all'"
                     :class="{ '-hokkaidoHover' : isHovering.hokkaido,
                               '-tohokuHover' : isHovering.tohoku,
                               '-hokurikuHover' : isHovering.hokuriku,
                               '-kantoHover' : isHovering.kanto,
                               '-tokaiHover' : isHovering.tokai,
                               '-kansaiHover' : isHovering.kansai,
                               '-chugokuHover' : isHovering.chugoku,
                               '-shikokuHover' : isHovering.shikoku,
                               '-kyushuHover' : isHovering.kyushu,
                               '-okinawaHover' : isHovering.okinawa, }">
                    <div class="inner">
                        <div class="select">Select a region</div>
                        <div class="link">
                            <ul class="region">
                                <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'hokkaido'}}); isHovering.hokkaido = false" @mouseover="isHovering.hokkaido = true" @mouseleave="isHovering.hokkaido = false">Hokkaido</a></li>
                                <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'tohoku'}}); isHovering.tohoku = false" @mouseover="isHovering.tohoku = true" @mouseleave="isHovering.tohoku = false">Tohoku</a></li>
                                <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'hokuriku'}}); isHovering.hokuriku = false" @mouseover="isHovering.hokuriku = true" @mouseleave="isHovering.hokuriku = false">Hokuriku Shinetsu</a></li>
                                <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'kanto'}}); isHovering.kanto = false" @mouseover="isHovering.kanto = true" @mouseleave="isHovering.kanto = false">Kanto</a></li>
                                <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'tokai'}}); isHovering.tokai = false" @mouseover="isHovering.tokai = true" @mouseleave="isHovering.tokai = false">Tokai</a></li>
                                <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'kansai'}}); isHovering.kansai = false" @mouseover="isHovering.kansai = true" @mouseleave="isHovering.kansai = false">Kansai</a></li>
                                <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'chugoku'}}); isHovering.chugoku = false" @mouseover="isHovering.chugoku = true" @mouseleave="isHovering.chugoku = false">Chugoku</a></li>
                                <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'shikoku'}}); isHovering.shikoku = false" @mouseover="isHovering.shikoku = true" @mouseleave="isHovering.shikoku = false">Shikoku</a></li>
                                <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'kyushu'}}); isHovering.kyushu = false" @mouseover="isHovering.kyushu = true" @mouseleave="isHovering.kyushu = false">Kyushu</a></li>
                                <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'okinawa'}}); isHovering.okinawa = false" @mouseover="isHovering.okinawa = true" @mouseleave="isHovering.okinawa = false">Okinawa</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="linkSp">
                        <ul class="region">
                            <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'hokkaido'}})">Hokkaido</a></li>
                            <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'tohoku'}})">Tohoku</a></li>
                            <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'hokuriku'}})">Hokuriku Shinetsu</a></li>
                            <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'kanto'}})">Kanto</a></li>
                            <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'tokai'}})">Tokai</a></li>
                            <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'kansai'}})">Kansai</a></li>
                            <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'chugoku'}})">Chugoku</a></li>
                            <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'shikoku'}})">Shikoku</a></li>
                            <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'kyushu'}})">Kyushu</a></li>
                            <li><a href="javascript:void(0)" @click="$router.push({ hash: '#region', query: {tab: 'region', map: 'okinawa'}})">Okinawa</a></li>
                        </ul>
                    </div>
                </div>
                <!-- /全国地図 -->

                <div class="map-hokkaido" v-if="activeMap === 'hokkaido'">
                    <div class="inner">
                        <div class="btnBack" @click="activeMap = 'all'"></div>
                        <div class="txtGroup">
                            <p class="txt1">Hokkaido</p>
                            <p class="txt2">Japan’s northern island is famous for its beautiful wilderness, world class powder snow, delicious seafood and fascinating indigenous culture. Just a short flight from Tokyo, Hokkaido is the perfect escape in all seasons</p>
                        </div>
                        <div class="thumb">
                            <ul>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/hokkaido01.jpg') no-repeat center center / cover"></span></li>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/hokkaido02.jpg') no-repeat center center / cover"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="map-tohoku" v-if="activeMap === 'tohoku'">
                    <div class="inner">
                        <div class="btnBack" @click="activeMap = 'all'"></div>
                        <div class="txtGroup">
                            <p class="txt1">Aomori, Akita, Iwate, Yamagata, Miyagi, Fukushima prefectures</p>
                            <p class="txt2">Fearsome festivals, fresh powder snow and vast fruit orchards-the rugged territory of Tohoku offers a new perspective on travel in Japan</p>
                        </div>
                        <div class="thumb">
                            <ul>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/tohoku01.jpg') no-repeat center center / cover"></span></li>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/tohoku02.jpg') no-repeat center center / cover"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="map-hokuriku" v-if="activeMap === 'hokuriku'">
                    <div class="inner">
                        <div class="btnBack" @click="activeMap = 'all'"></div>
                        <div class="txtGroup">
                            <p class="txt1">Niigata, Toyama, Ishikawa, Fukui, Nagano prefectures</p>
                            <p class="txt2">An easily accessible slice of rural Japan offering unrivaled mountainscapes and coastlines, endless outdoor adventure and amazing ocean fare</p>
                        </div>
                        <div class="thumb">
                            <ul>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/hokurikushinetsu01.jpg') no-repeat center center / cover"></span></li>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/hokurikushinetsu02.jpg') no-repeat center center / cover"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="map-kanto" v-if="activeMap === 'kanto'">
                    <div class="inner">
                        <div class="btnBack" @click="activeMap = 'all'"></div>
                        <div class="txtGroup">
                            <p class="txt1">Tokyo, Kanagawa, Chiba, Saitama, Ibaraki, Tochigi, Gunma prefectures</p>
                            <p class="txt2">Anchored by Tokyo, the world’s biggest metropolis, Kanto also has rustic mountain getaways and gorgeous subtropical islands</p>
                        </div>
                        <div class="thumb">
                            <ul>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/kanto01.jpg') no-repeat center center / cover"></span></li>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/kanto02.jpg') no-repeat center center / cover"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="map-tokai" v-if="activeMap === 'tokai'">
                    <div class="inner">
                        <div class="btnBack" @click="activeMap = 'all'"></div>
                        <div class="txtGroup">
                            <p class="txt1">Yamanashi, Shizuoka, Gifu, Aichi, Mie prefectures</p>
                            <p class="txt2">Hallmark attractions such as Mt. Fuji and Takayama coexist with major cities and famous heritage sites in the center of Japan</p>
                        </div>
                        <div class="thumb">
                            <ul>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/tokai01.jpg') no-repeat center center / cover"></span></li>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/tokai02.jpg') no-repeat center center / cover"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="map-kansai" v-if="activeMap === 'kansai'">
                    <div class="inner">
                        <div class="btnBack" @click="activeMap = 'all'"></div>
                        <div class="txtGroup">
                            <p class="txt1">Kyoto, Osaka, Shiga, Hyogo, Nara prefectures</p>
                            <p class="txt2">The Kansai region is one of contrasts, from the glittering lights and culinary delights of Osaka and Kobe to the cultural treasures of Kyoto and Nara</p>
                        </div>
                        <div class="thumb">
                            <ul>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/kansai01.jpg') no-repeat center center / cover"></span></li>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/kansai02.jpg') no-repeat center center / cover"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="map-chugoku" v-if="activeMap === 'chugoku'">
                    <div class="inner">
                        <div class="btnBack" @click="activeMap = 'all'"></div>
                        <div class="txtGroup">
                            <p class="txt1">Tottori, Shimane, Okayama, Hiroshima, Yamaguchi prefectures</p>
                            <p class="txt2">Japan’s less-explored western frontier, where the weather is warmer and the pace of life is slower</p>
                        </div>
                        <div class="thumb">
                            <ul>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/chugoku01.jpg') no-repeat center center / cover"></span></li>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/chugoku02.jpg') no-repeat center center / cover"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="map-shikoku" v-if="activeMap === 'shikoku'">
                    <div class="inner">
                        <div class="btnBack" @click="activeMap = 'all'"></div>
                        <div class="txtGroup">
                            <p class="txt1">Tokushima, Kagawa, Ehime, Kochi prefectures</p>
                            <p class="txt2">Providing the stage for an ancient pilgrimage route, island-hopping, fevered dancing, and natural wonders</p>
                        </div>
                        <div class="thumb">
                            <ul>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/shikoku01.jpg') no-repeat center center / cover"></span></li>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/shikoku02.jpg') no-repeat center center / cover"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="map-kyushu" v-if="activeMap === 'kyushu'">
                    <div class="inner">
                        <div class="btnBack" @click="activeMap = 'all'"></div>
                        <div class="txtGroup">
                            <p class="txt1">Fukuoka, Saga, Nagasaki, Oita, Kumamoto, Miyazaki, Kagoshima prefectures</p>
                            <p class="txt2">The southern island of Kyushu is home to hot springs, rugged geography, undeveloped beaches and volcanoes ranging from sleepy to smoky</p>
                        </div>
                        <div class="thumb">
                            <ul>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/kyushu01.jpg') no-repeat center center / cover"></span></li>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/kyushu02.jpg') no-repeat center center / cover"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="map-okinawa" v-if="activeMap === 'okinawa'">
                    <div class="inner">
                        <div class="txtGroup">
                            <p class="txt1">Okinawa prefecture</p>
                            <p class="txt2">Discover a distinct island culture born of  subtropical sun, white sand, mangrove jungles and  the age of the Ryukyu Kings</p>
                        </div>
                        <div class="thumb">
                            <ul>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/okinawa01.jpg') no-repeat center center / cover"></span></li>
                                <li><span style="background: url('https://cb-contents.s3.ap-northeast-1.amazonaws.com/articles/images/full_list/okinawa02.jpg') no-repeat center center / cover"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- 北海道 -->
                <div class="articleBlock" v-if="activeMap === 'all' || activeMap === 'hokkaido'">
                    <div class="group">
                        <h2 class="ttl">Hokkaido</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.hokkaido)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'hokkaido'], article.attributes.url, categoryId['hokkaido'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'hokkaido'], article.attributes.url, categoryId['hokkaido'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'hokkaido'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'hokkaido', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /北海道 -->
                <!-- 東北 -->
                <div class="articleBlock" :class="{ '-topGray2White' : activeMap === 'all' }" v-if="activeMap === 'all' || activeMap === 'tohoku'">
                    <div class="group">
                        <h2 class="ttl">Tohoku</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.tohoku)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'tohoku'], article.attributes.url, categoryId['tohoku'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'tohoku'], article.attributes.url, categoryId['tohoku'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'tohoku'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'tohoku', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /東北 -->
                <!-- 北陸 -->
                <div class="articleBlock" :class="{ '-topWhite2Gray' : activeMap === 'all' }" v-if="activeMap === 'all' || activeMap === 'hokuriku'">
                    <div class="group">
                        <h2 class="ttl">Hokuriku Shinetsu</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.hokuriku)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'hokuriku'], article.attributes.url, categoryId['hokuriku'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'hokuriku'], article.attributes.url, categoryId['hokuriku'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'hokuriku'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'hokuriku', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /北陸 -->
                <!-- 関東 -->
                <div class="articleBlock" :class="{ '-topGray2White' : activeMap === 'all' }" v-if="activeMap === 'all' || activeMap === 'kanto'">
                    <div class="group">
                        <h2 class="ttl">Kanto</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.kanto)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'kanto'], article.attributes.url, categoryId['kanto'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'kanto'], article.attributes.url, categoryId['kanto'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'kanto'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'kanto', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /関東 -->
                <!-- 東海 -->
                <div class="articleBlock" :class="{ '-topWhite2Gray' : activeMap === 'all' }" v-if="activeMap === 'all' || activeMap === 'tokai'">
                    <div class="group">
                        <h2 class="ttl">Tokai</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.tokai)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'tokai'], article.attributes.url, categoryId['tokai'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'tokai'], article.attributes.url, categoryId['tokai'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'tokai'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'tokai', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /東海 -->
                <!-- 関西 -->
                <div class="articleBlock" :class="{ '-topGray2White' : activeMap === 'all' }" v-if="activeMap === 'all' || activeMap === 'kansai'">
                    <div class="group">
                        <h2 class="ttl">Kansai</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.kansai)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'kansai'], article.attributes.url, categoryId['kansai'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'kansai'], article.attributes.url, categoryId['kansai'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'kansai'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'kansai', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /関西 -->
                <!-- 中国 -->
                <div class="articleBlock" :class="{ '-topWhite2Gray' : activeMap === 'all' }" v-if="activeMap === 'all' || activeMap === 'chugoku'">
                    <div class="group">
                        <h2 class="ttl">Chugoku</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.chugoku)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'chugoku'], article.attributes.url, categoryId['chugoku'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'chugoku'], article.attributes.url, categoryId['chugoku'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'chugoku'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'chugoku', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /中国 -->
                <!-- 四国 -->
                <div class="articleBlock" :class="{ '-topGray2White' : activeMap === 'all' }" v-if="activeMap === 'all' || activeMap === 'shikoku'">
                    <div class="group">
                        <h2 class="ttl">Shikoku</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.shikoku)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'shikoku'], article.attributes.url, categoryId['shikoku'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'shikoku'], article.attributes.url, categoryId['shikoku'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'shikoku'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'shikoku', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /四国 -->
                <!-- 九州 -->
                <div class="articleBlock" :class="{ '-topWhite2Gray' : activeMap === 'all' }" v-if="activeMap === 'all' || activeMap === 'kyushu'">
                    <div class="group">
                        <h2 class="ttl">Kyushu</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.kyushu)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'kyushu'], article.attributes.url, categoryId['kyushu'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'kyushu'], article.attributes.url, categoryId['kyushu'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'kyushu'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'kyushu', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /九州 -->
                <!-- 沖縄 -->
                <div class="articleBlock" :class="{ '-topWhite2Gray' : activeMap === 'all' }" v-if="activeMap === 'all' || activeMap === 'okinawa'">
                    <div class="group">
                        <h2 class="ttl">Okinawa</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.okinawa)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'okinawa'], article.attributes.url, categoryId['okinawa'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['region', 'okinawa'], article.attributes.url, categoryId['okinawa'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'okinawa'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" @click.prevent="readMore($event,'okinawa', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /沖縄 -->
            </div>
            <!-- /地域 -->

            <!-- （３）カテゴリ -->
            <div v-if="activeTabMenu === 'byCategory'" class="tabBody-category">
                <div class="category">
                    <div class="leftArea">Which category <br>are you interested in?</div>
                    <div class="rightArea">
                        <ul>
                            <li><a href="javascript:void(0)" v-scroll-to="{ el: '#history_and_culture', offset: -100 }">History and culture</a></li>
                            <li><a href="javascript:void(0)" v-scroll-to="{ el: '#nature', offset: -100 }">Nature</a></li>
                            <li><a href="javascript:void(0)" v-scroll-to="{ el: '#religion_and_beliefs', offset: -100 }">Religion and beliefs</a></li>
                            <li><a href="javascript:void(0)" v-scroll-to="{ el: '#cultural_experiences', offset: -100 }">Cultural experiences</a></li>
                        </ul>
                    </div>
                </div>
                <div class="articleBlock" id="history_and_culture">
                    <div class="group">
                        <h2 class="ttl">History and culture</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.history)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['category', 'history_and_culture'], article.attributes.url, categoryId['history'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['category', 'history_and_culture'], article.attributes.url, categoryId['history'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'history_and_culture'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'history_and_culture', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="articleBlock -topGray2White" id="nature">
                    <div class="group">
                        <h2 class="ttl">Nature</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.nature)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['category', 'nature'], article.attributes.url, categoryId['nature'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['category', 'nature'], article.attributes.url, categoryId['nature'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'nature'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'nature', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="articleBlock -topWhite2Gray" id="religion_and_beliefs">
                    <div class="group">
                        <h2 class="ttl">Religion and beliefs</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.religion)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['category', 'religion_and_beliefs'], article.attributes.url, categoryId['religion'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['category', 'religion_and_beliefs'], article.attributes.url, categoryId['religion'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'religion_and_beliefs'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'religion_and_beliefs', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="articleBlock -topGray2White" id="cultural_experiences">
                    <div class="group">
                        <h2 class="ttl">Cultural experiences</h2>
                        <div class="article">
                            <ul>
                                <li v-for="article in filterByCategory(categoryId.cultural)" :key="article.id">
                                    <p class="img">
                                        <a href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['category', 'cultural_experiences'], article.attributes.url, categoryId['cultural'])" :style="{'pointer-events' : article.attributes.content !== null ? '' : 'none'}">
                                            <span><picture>
                                                <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                                <img :src="article.attributes.thumbnail_url" :alt="article.attributes.thumbnail_url">
                                            </picture></span>
                                        </a>
                                    </p>
                                    <div class="txtGroup">
                                        <p class="txt1">
                                            <a v-if="article.attributes.content !== null" href="javascript:void(0)" @click="storyPageButtonHasClicked(article.id, ['category', 'cultural_experiences'], article.attributes.url, categoryId['cultural'])" v-html="article.attributes.title"></a>
                                            <span v-else v-html="article.attributes.title"></span>
                                        </p>
                                        <p v-if="article.attributes.description !== null" class="txt2" v-html="article.attributes.description.slice(0, 200) + '...'" :id="article.id + 'cultural_experiences'"></p>
                                        <div class="btnGroup">
                                            <p class="btn1">
                                                <a v-if="article.attributes.description !== null" href="javascript:void(0)" @click.prevent="readMore($event,'cultural_experiences', article)">Read More</a>
                                            </p>
                                            <p class="btn2">
                                                <a v-if="article.discoverUrl" :href="article.discoverUrl" target="_blank">Discover</a>
                                                <a v-if="article.luxuryUrl" :href="article.luxuryUrl" target="_blank">Luxury</a>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /カテゴリ -->

        </div>

    </div>
</template>

<script>
    import ApiRouter from "../../components/Systems/ApiRouter";
    import JsonLd from "@/components/JsonLd/JsonLd.vue";

    export default {
        name: "FullList",
        components: {JsonLd},
        mixins: [ApiRouter],
        data: function () {
            return {
                articles: [],
                activeTabMenu: 'fullList',
                activeMap: 'all',
                regions: ['all', 'hokkaido', 'tohoku', 'hokuriku', 'kanto', 'tokai', 'kansai', 'chugoku', 'shikoku', 'kyushu', 'okinawa'],
                isHovering: {
                    hokkaido: false,
                    tohoku: false,
                    hokuriku: false,
                    kanto: false,
                    tokai: false,
                    kansai: false,
                    chugoku: false,
                    shikoku: false,
                    kyushu: false,
                    okinawa: false,
                },
                categoryId: {
                    hokkaido: '3b3b8d69-262d-434d-a898-104c29603957',
                    tohoku: 'f87065e7-c500-427f-bfb3-730405f1d4ec',
                    kanto: '6ec59d63-f6d2-469f-b190-aac37c80c96b',
                    hokuriku: '26a2cce4-c195-4319-b6e1-0265864bf4dc',
                    tokai: '1326f996-cb65-420f-a6a6-831f75ff763e',
                    kansai: '09788e7d-5beb-4d3b-b644-32d3a36f4755',
                    chugoku: '735171a6-e699-4b4b-bb47-8082272b171b',
                    shikoku: '4744b2f3-7668-439a-9720-2a18f8107d1b',
                    kyushu: '0c707f65-f788-4cb0-916a-131b42ce72cc',
                    okinawa: 'a1f471b5-cb43-4bf1-b076-0348c325560e',
                    history: 'e70710ab-189f-4a39-8a09-866845792550',
                    nature: 'a42f8d28-d02d-466c-a1e9-0cc31fd7fe99',
                    religion: 'fa6988ce-f5f3-4953-9c43-c532796fe392',
                    cultural: 'b5840e33-e987-4243-b05a-798a1e29cb9b',
                },
                jsonld: {
                    "@context": "https://schema.org",
                    "@graph": [
                        {
                            "@type": "Article",
                            "mainEntityOfPage": window.location.href,
                            "headline": 'All Japan Heritage Sites',
                            "description": "Japan Heritage ties together historical sites, shrines, temples, traditional arts, castles, armor," +
                                "and other cultural assets. Find photos, videos, tourist information, and more.",
                            "image": [
                                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAABgCAYAAAC0TppOAAAABHNCSVQICAgIfAhkiAAAAd5JREFUeF7d3DtOAzEUBVB7SeyCFRBRAQWp0dDQkY6K9NNS8VkAu2NgEinRkPn48z735laWKx+9xnqyX/xqm4efGC6u7re3MYYuECZ+tM0mxvjche5ttd7eEBpC7A/92T6+/K2eWCE7BDvkgGCGDBCskBMEI2QUwQaZRDBBZhEskEUEAyQJgQ5JRiBDshCokGwEIqQIgQYpRiBBqhAokGoEAkQE4Q0RQ3hCRBFeEHGEB0QFYQ1RQ1hCVBFWEHWEBcQEoQ0xQ2hCTBFaEHOEBsQFIQ1xQ0hCXBFSEHeEBAQCUQuBQdRAoBBDSHhfrV+v+72lwCFKIJCIXAgsIgcCjUiFwCNSIBSIJQgNYg5ChZiC0CHGIJSIPaT5DjFehtDdUSKOr4L2VxM6xH9AXxUqxBiACjEFoEHMASgQSwB4RAoAGpEKgEXkACARuQA4RAkAClEKgEHUACAQtQB3hATAFSEFcENIAlwQ0gBzhAbAFKEFMENoAkwQ2gB1hAVAFWH52Uql22EJUKmENUAc4QEQRXgBxBCeABGEN6AagQCoQqAAihFIgCIEGiAbgQjIQqACkhHIgCQEOmARwQCYRbAAJhFMgFEEG+AEwQgYIFgBBwQzYIc4i1k2ZzFVqC8He34BnstzlSi4Q8IAAAAASUVORK5CYII="
                            ],
                            "datePublished": "2020/04/14",
                            "dateModified": "2024/11/14",
                            "author": [{
                                "@type": "Organization",
                                "name": "Japan National Tourism Organization",
                                "url": "https://www.japan.travel/japan-heritage/"
                            }]
                        },
                        {
                            "@type": "BreadcrumbList",
                            "itemListElement":  [{
                                "@type": "ListItem",
                                "position": 1,
                                "name": "TOP",
                                "item": "https://www.japan.travel/japan-heritage/"
                            },{
                                "@type": "ListItem",
                                "position": 2,
                                "name": "All Japan Heritage Sites",
                                "item": "https://www.japan.travel/japan-heritage/full_list"
                            }]
                        }
                    ]
                }
            }
        },
        created: function () {
            this.getQuery();
            this.loadData();
            document.title = 'Japan Heritage full list | Stories and travel information | JNTO'
        },
        mounted: function () {
            if (this.$route.hash) {
                this.scrollToHash();
            }
        },
        methods: {
            loadData: function () {
                window.axios.get(this.routes.articles)
                    .then((response) => {
                        this.articles = response.data.data;
                    }).finally(() => {
                    if (this.$route.hash) {
                        this.scrollToHash();
                    }
                });
            },
            storyPageButtonHasClicked: function (id, breadcrumb, url, categoryId) {
                this.$router.push({name: 'Popular', params: {id: id, page: 'about', breadcrumb: breadcrumb, categoryId: categoryId, url: url}});
            },
            download: function (id) {
                window.axios.get(this.routes.downloadArticles(id))
                    .then((response) => {
                        this.sendDownloadResponse(response.data.download_url);
                    });
            },
            sendDownloadResponse: function (url) {
                const link = document.createElement('a');
                link.href = url;
                link.click();
            },
            scroll: function () {
                scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            },
            scrollToHash: function () {
                const hash = this.$route.hash;
                this.$scrollTo(hash, 1, {offset: -100});
            },
            readMore: function(e, idName, article) {
                const txtGroupElement = e.currentTarget.closest('.txtGroup');
                txtGroupElement.classList.add('-expand');
                document.getElementById(article.id + idName).innerHTML = article.attributes.description;
            },
            getQuery: function () {
                const tab = this.$route.query.tab;
                const map = this.$route.query.map;

                switch (tab) {
                    case 'region':
                        this.activeTabMenu = 'byRegion';
                        if (map && this.regions.includes(map)) this.activeMap = map;
                        break;
                    case 'category':
                        this.activeTabMenu = 'byCategory';
                        break;
                    default:
                        this.activeTabMenu = 'fullList';
                        break;
                }
            },
            getWebPUrl(url) {
                return url.replace('/images', '/webp').replace(/\.(jpg|jpeg|png)$/, ".webp");
            }
        },
        watch: {
            $route() {
                this.getQuery();
                if (this.$route.hash) {
                    this.scrollToHash();
                }
            }
        },
        computed: {
            filterByCategory() {
                return (value) => {
                    if (!this.articles) return [];
                    return this.articles.filter(article =>
                        article.relationships.categories.some(category => category.id === value)
                    );
                }
            }
        }
    }
</script>

<style src="./FullList.scss" lang="scss" scoped/>
